export default __webpack_public_path__ + "static/media/004-barrier.75ead73a.png";